const HelpTable = () => {
  return (
    <div>
      <div>
        <h3 className="mt-1 mb-1">General</h3>
        <table className="table-bordered">
          <tbody>
            <tr>
              <td>
                <code>&#123;[MT0]&#125;</code>
              </td>
              <td>Last quarter's FIRST month (Oct, Jan, Apr, Jul)</td>
            </tr>
            <tr>
              <td>
                <code>&#123;[MT1]&#125;</code>
              </td>
              <td>Last quarter's SECOND month (Nov, Feb, May, Aug)</td>
            </tr>
            <tr>
              <td>
                <code>&#123;[MT2]&#125;</code>
              </td>
              <td>Last quarter's THIRD month (Dev, Mar, Jun, Sep)</td>
            </tr>
            <tr>
              <td>
                <code>&#123;[FM]&#125;</code>
              </td>
              <td>Full month for this Surcharge (September, March, August, etc.)</td>
            </tr>
            <tr>
              <td>
                <code>&#123;[ED]&#125;</code>
              </td>
              <td>Effective date in format (March 1, 2019)</td>
            </tr>
            <tr>
              <td>
                <code>&#123;[H2FEA]&#125;</code>
              </td>
              <td>The surcharge increase amount</td>
            </tr>
            <tr>
              <td>
                <code>&#123;[I:HenryHubNGRate]&#125;</code>
              </td>
              <td>Index value for Henry hub. Reference below table for all index names</td>
            </tr>
            <tr>
              <td>
                <code>&#123;[I:EnergyKwh:NOLA]&#125;</code>
              </td>
              <td>Index value but for a specific plant. (NOLA, SACR, SARN)</td>
            </tr>
            <tr>
              <td>
                <code>&#123;[IQM0:HenryHubNGRate]&#125;</code>
              </td>
              <td> For quarterly customers, this will give the FIRST month in the quarter's value. IQM1 for second, IQM2 for third</td>
            </tr>
            <tr>
              <td>
                <code>&#123;[IQA:HenryHubNGRate]&#125;</code>
              </td>
              <td> For quarterly customers, this will give the average of the index over the 3 months</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <h3 className="mt-1 mb-1">Index Names</h3>
        <table className="table-bordered">
          <tbody>
            <tr>
              <td>
                <code>EstPGETransportation</code>
              </td>
              <td>Est PG&E Transportation w 7.5 tax- $/MMBtu</td>
            </tr>
            <tr>
              <td>
                <code>DemandForFirst4000KVA</code>
              </td>
              <td>Demand $ for First 4000 KVA</td>
            </tr>
            <tr>
              <td>
                <code>NGIPGECityGate</code>
              </td>
              <td>NGI PG&E CITYGATE - $/MMBTU</td>
            </tr>
            <tr>
              <td>
                <code>DemandChargeRate</code>
              </td>
              <td>Demand Charge Rate</td>
            </tr>
            <tr>
              <td>
                <code>PowerBillingPeriod</code>
              </td>
              <td>Power Billing Period</td>
            </tr>
            <tr>
              <td>
                <code>HenryHubNGRate</code>
              </td>
              <td>Henry Hub NG rate - $/MMBtu</td>
            </tr>
            <tr>
              <td>
                <code>DemandChargeRate</code>
              </td>
              <td>Demand Charge Rate</td>
            </tr>
            <tr>
              <td>
                <code>FuelEnergyFirmDemandKwh</code>
              </td>
              <td>Fuel, Energy, Firm demand $/kwh</td>
            </tr>
            <tr>
              <td>
                <code>CanadianCGPR</code>
              </td>
              <td>Canadian CGPR - USD/MMBTU (Prelim)</td>
            </tr>
            <tr>
              <td>
                <code>EnergyKwh</code>
              </td>
              <td>Energy $/kwh</td>
            </tr>
            <tr>
              <td>
                <code>USWeeklyDieselOnHighway</code>
              </td>
              <td>U.S. Weekly Diesel On-Highway as reported by EIA</td>
            </tr>
            <tr>
              <td>
                <code>SacramentoNGRate</code>
              </td>
              <td>Sacramento NG rate, incl taxes & fees - $/MMBtu</td>
            </tr>
            <tr>
              <td>
                <code>SarniaDawnFOM</code>
              </td>
              <td>Sarnia Dawn FOM - USD/MMBTU</td>
            </tr>
            <tr>
              <td>
                <code>TotalPowerKwh</code>
              </td>
              <td>Total Power $/kwh</td>
            </tr>
            <tr>
              <td>
                <code>CoralAdder</code>
              </td>
              <td>Coral Adder - $/MMBtu</td>
            </tr>
            <tr>
              <td>
                <code>SacramentoUserTax</code>
              </td>
              <td>Sacramento User Tax - $/MMBtu</td>
            </tr>
            <tr>
              <td>
                <code>FullProFormaPowerKwh</code>
              </td>
              <td>Full pro forma power $/kwh</td>
            </tr>
            <tr>
              <td>
                <code>DemandForFirst750KVA</code>
              </td>
              <td>Demand $ for First 750 KVA</td>
            </tr>
            <tr>
              <td>
                <code>ExchangeRateUSCN</code>
              </td>
              <td>Exchange rate US$/CN$</td>
            </tr>
            <tr>
              <td>
                <code>DemandForFirst5500KVA</code>
              </td>
              <td>Demand $ for First 4000 KVA</td>
            </tr>
            <tr>
              <td>
                <code>FuelAdjustmentKwh</code>
              </td>
              <td>Fuel Adjustment $/kwh</td>
            </tr>
            <tr>
              <td>
                <code>HydrocarbonsMMBtu</code>
              </td>
              <td>Hydrocarbons $/MMBtu</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HelpTable;
